/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_To_UseInputs */

const en_how_to_use = /** @type {(inputs: How_To_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How to use?`)
};

const ar_how_to_use = /** @type {(inputs: How_To_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كيفية الاستخدام؟`)
};

const de_how_to_use = /** @type {(inputs: How_To_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie wird es verwendet?`)
};

const es_how_to_use = /** @type {(inputs: How_To_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo utilizarlo?`)
};

const fr_how_to_use = /** @type {(inputs: How_To_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment utiliser ?`)
};

const it_how_to_use = /** @type {(inputs: How_To_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come si usa?`)
};

const ja_how_to_use = /** @type {(inputs: How_To_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使い方`)
};

const ko_how_to_use = /** @type {(inputs: How_To_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`어떻게 사용하나요?`)
};

const pt_br_how_to_use = /** @type {(inputs: How_To_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como usar?`)
};

const ru_how_to_use = /** @type {(inputs: How_To_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Как пользоваться?`)
};

const th_how_to_use = /** @type {(inputs: How_To_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ใช้อย่างไร?`)
};

const tr_how_to_use = /** @type {(inputs: How_To_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nasıl kullanılır?`)
};

const zh_cn_how_to_use = /** @type {(inputs: How_To_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如何使用？`)
};

const zh_tw_how_to_use = /** @type {(inputs: How_To_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如何使用？`)
};

/**
* | output |
* | --- |
* | "How to use?" |
*
* @param {How_To_UseInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const how_to_use = /** @type {((inputs?: How_To_UseInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_To_UseInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_how_to_use(inputs)
	if (locale === "ar") return ar_how_to_use(inputs)
	if (locale === "de") return de_how_to_use(inputs)
	if (locale === "es") return es_how_to_use(inputs)
	if (locale === "fr") return fr_how_to_use(inputs)
	if (locale === "it") return it_how_to_use(inputs)
	if (locale === "ja") return ja_how_to_use(inputs)
	if (locale === "ko") return ko_how_to_use(inputs)
	if (locale === "pt_br") return pt_br_how_to_use(inputs)
	if (locale === "ru") return ru_how_to_use(inputs)
	if (locale === "th") return th_how_to_use(inputs)
	if (locale === "tr") return tr_how_to_use(inputs)
	if (locale === "zh_cn") return zh_cn_how_to_use(inputs)
	return zh_tw_how_to_use(inputs)
});